const prefix = 'portal';

const SET_PRODUCT = `${prefix}/SET_PRODUCT`;

const RESET = `${prefix}/RESET`;

const SET_LOADING = `${prefix}/SET_LOADING`;

export { SET_PRODUCT, RESET, SET_LOADING };
